import React from "react";
import { Grid, Section, Typography } from "../../core";
import { theme } from "../../styles";
import CompanyGeneral from "./General";
// import { useHistory } from "react-router-dom";
import { Layout, Menu } from "antd";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import YarnQuality from "./YarnQuality";
import ClothQuality from "./ClothQuality";
import TaxRate from "./TaxRate";
import Weave from "./Weave";

import Selvedge from "./Selvedge";

import HSCode from "./HsCode";

import { updateCurrentPath } from "../../redux/Action/pageRoot";

// import ManageRole from "./ManageRoles";
import ManageRole from "./ManageRoles";
const { textColor } = theme;

const { Content, Sider } = Layout;
const typoProps = {
  color: textColor.primary,
  as: "h4",
  weight: "600",
  letterSpacing: "0.2px",
};
const StyledLayout = styled(Layout)`
  margin: 30px 0px;
  aside ul,
  .ant-layout-sider {
    background: #233b67;
    border: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #a2a5bd;
  }
  .ant-layout {
    background: white !important;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
  .ant-menu-item:hover {
    color: white !important;
    background: rgba(255, 255, 255, 0.2);
  }
  .ant-menu-inline .ant-menu-item::after {
    border-right: none;
  }
`;

const Container = styled.div`
  margin: 50px 0px;
`;

const Setting = () => {
  // let history = useHistory();
  const dispatch = useDispatch();
  dispatch(updateCurrentPath("Setting"));
  // const pathname = history.location.pathname;
  const [view, setView] = React.useState("Company");
  // const [state, setstate] = useState(null);

  // var compoName = pathname.substr(1);
  function clickHandler({ key }) {
    // history.push(`/${key}`);
    setView(key);
  }

  return (
    <Grid>
      <Container>
        <Section padding="25px 30px">
          <Typography noMargin {...typoProps}>
            {view.toUpperCase()}
          </Typography>
        </Section>
        <StyledLayout>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
              console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}
          >
            <div className="logo" />
            <Menu
              mode="inline"
              defaultSelectedKeys={["1"]}
              onClick={clickHandler}
            >
              <Menu.Item key="Company">Company Info</Menu.Item>
              <Menu.Item key="manage-roles">Manage Roles</Menu.Item>
              <Menu.Item key="Yarn-Quality">Yarn Quality</Menu.Item>
              <Menu.Item key="Cloth-Quality">Cloth Quality</Menu.Item>
              <Menu.Item key="Tax-Rate">Tax Rate</Menu.Item>
              <Menu.Item key="Weave">Weave</Menu.Item>
              <Menu.Item key="Selvedge">Salvedge</Menu.Item>
              <Menu.Item key="Hs Code">HS Code</Menu.Item>
            </Menu>
          </Sider>
          <Layout>
            <Content style={{ margin: "24px 16px 0" }}>
              <div
                className="site-layout-background"
                style={{ padding: 24, minHeight: 360 }}
              >
                {view === "Company" ? (
                  <CompanyGeneral />
                ) : view === "manage-roles" ? (
                  <ManageRole />
                ) : view === "Yarn-Quality" ? (
                  <YarnQuality />
                ) : view === "Cloth-Quality" ? (
                  <ClothQuality />
                ) : view === "Tax-Rate" ? (
                  <TaxRate />
                ) : view === "Weave" ? (
                  <Weave />
                ) : view === "Selvedge" ? (
                  <Selvedge />
                ) : view === "Hs Code" ? (
                  <HSCode />
                ) : null}
              </div>
            </Content>
          </Layout>
        </StyledLayout>
      </Container>
    </Grid>
  );
};

export default Setting;
